import { useEffect, useState, type EffectCallback } from 'react';

import type { CollectionStore, RelCollectionStore } from '@/stores/collection';

export const defaultMassUpdateCashedStores = (cachedStores: CollectionStore<any, any>[]) => {
  const promises = cachedStores.map((cachedStore) => cachedStore.asyncItems());
  return Promise.all(promises);
};

export const useMassUpdateCashedStores = (cachedStores: CollectionStore<any, any>[]) => {
  const [loading, setLoading] = useState<boolean>(true);

  const effect: EffectCallback = () => {
    setLoading(true);

    defaultMassUpdateCashedStores(cachedStores).then(() => setLoading(false));
  };

  // Intentionally run once on mount; callers pass inline arrays so adding cachedStores to deps would re-run every render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);

  return { loading, setLoading };
};

export const useMassUpdateCashedRelStores = (cachedStores: RelCollectionStore<any, any>[], relId: number) => {
  const [loading, setLoading] = useState<boolean>(false);

  const effect: EffectCallback = () => {
    setLoading(true);

    Promise.all(cachedStores.map((cachedStore) => cachedStore.asyncItems(relId, { limit: 10 }))).then(() =>
      setLoading(false),
    );
  };

  // Same as above: mount-only; adding cachedStores/relId would cause re-runs every render due to inline array/params.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);

  return { loading, setLoading };
};
